import { Content } from '../../types';

export const haLongBayContent: Content = {
  title: 'הא לונג ביי - פנינת הטבע של וייטנאם',
  imageUrl: '/images/vietnam/ha-long-bay/ha-long-bay-wide.jpeg',
  introduction:
    'מפרץ הא לונג (Hạ Long Bay), הממוקם בצפון וייטנאם, הינו אחד מאתרי התיירות המפורסמים ביותר במדינה ונחשב לאחד מהנופים הימיים היפים בעולם. המפרץ, המשתרע על שטח של כ-1,550 קמ"ר, הינו חלק ממפרץ טונקין שבים סין הדרומי ובו יותר מ-2,000 איים גירניים מרהיבים המכוסים בצמחייה עבותה, המזדקרים מתוך המים הצלולים.',
  sections: [
    {
      title: 'אתר מורשת עולמית ואחד משבעת פלאי עולם הטבע',
      type: 'text',
      content:
        'בשנת 1994 הכריז אונסק"ו על כמחצית משטח המפרץ כאתר מורשת עולמית בשל ערכו הגאולוגי, האקולוגי והתרבותי. בשנת 2011 הוכרז המפרץ כאחד משבעת פלאי עולם הטבע, מה שהגביר עוד יותר את הפופולריות שלו בקרב מטיילים מכל רחבי העולם.',
    },
    {
      title: 'האטרקציות המרכזיות במפרץ הא לונג',
      type: 'list',
      content: [
        {
          subtitle: 'שייט במפרץ',
          text: 'הדרך המומלצת ביותר לחוות את היופי של המפרץ הינה באמצעות שייט, הנע בין טיולי יום לסיורים בני מספר ימים. הסיורים כוללים עצירות באיים שונים, שחייה, שייט קיאקים וביקור במערות.',
        },
        {
          subtitle: 'מערות ייחודיות',
          text: 'המפרץ מכיל מערות רבות ומרשימות, בהן:\nמערת הנטיפים האנג דאו גו (Hang Dau Go) – מערה גדולה ומרהיבה עם תצורות נטיפים מרשימות.\nמערת סונג סוט (Sung Sot Cave) – אחת המערות הפופולריות במפרץ, הידועה באולמות הענקיים שלה ובנטיפיה המרהיבים.\nמערת תאיין קונג (Thien Cung Cave) – מערה מרהיבה עם תצורות סלע יוצאות דופן, המזכירות ציורי נוף מהאגדות.',
        },
        {
          subtitle: 'האי טי טופ (Ti Top Island)',
          text: 'אי קטן המציע חוף חולי נעים ותצפית פנורמית מרהיבה על המפרץ.',
        },
        {
          subtitle: 'האי קטבה (Cat Ba Island)',
          text: 'האי הגדול ביותר במפרץ, שהוכרז כפארק לאומי ומהווה יעד תיירותי מרכזי עם חופים יפים, מסלולי טיול בטבע, בתי מלון ומסעדות.',
        },
        {
          subtitle: 'כפרי דייגים צפים',
          text: 'ביקור בכפרי הדייגים המסורתיים, כגון כפר ואן גיה (Vung Vieng), מספק הצצה לאורח החיים הייחודי של המקומיים החיים על פני המים.',
        },
        {
          subtitle: 'שייט קיאקים',
          text: 'אחת החוויות המרגשות ביותר במפרץ הינה שייט קיאקים בין האיים, דרך לגונות נסתרות ומנהרות טבעיות מרשימות.',
        },
      ],
    },
    {
      title: 'עונות מומלצות לביקור',
      type: 'text',
      content:
        'המפרץ נהנה מאקלים טרופי, מה שמאפשר לבקר בו במהלך כל השנה. עם זאת, התקופה המומלצת ביותר הינה העונה היבשה (נובמבר-אפריל), אז מזג האוויר נעים יותר והראות טובה יותר. בעונה הרטובה (מאי-אוקטובר), ייתכנו גשמים וסופות טרופיות, אך היתרון הוא פחות עומס של תיירים ומחירים נמוכים יותר.',
    },
    {
      title: 'אפשרויות לינה',
      type: 'list',
      content: [
        {
          subtitle: 'לינה על אוניות קרוז',
          text: 'חוויה ייחודית הכוללת הפלגה רומנטית בין האיים, ארוחות גורמה, פעילויות על הסיפון ולינה בחדרים מפנקים.',
        },
        {
          subtitle: 'בתי מלון ובתי הארחה באי קטבה',
          text: 'קטבה מציע מגוון אפשרויות לינה המתאימות לכל תקציב, כולל מלונות יוקרה, הוסטלים ידידותיים למטיילים ובונגלוס מול הים.',
        },
        {
          subtitle: 'לינה בהאנוי עם טיול יומי למפרץ',
          text: 'למי שמעדיף ללון בהאנוי, ניתן לצאת לטיול יום מאורגן למפרץ ולחזור בערב לבירה הווייטנאמית.',
        },
      ],
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, מפרץ הא לונג הינו יעד חובה למבקרים בוייטנאם. עם נופים עוצרי נשימה, אטרקציות מגוונות ושפע של פעילויות, הביקור במפרץ מבטיח חוויה בלתי נשכחת לכל מטייל.',
    },
  ],
};
